/**
 * MitEvida API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ExpectedConsumptionOverviewResponse } from '../model/models';
import { ExpectedConsumptionYearResponse } from '../model/models';
import { UpdateExpectedConsumptionRequest } from '../model/models';
import { ValidationErrorResponse } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ExpectedConsumptionService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param customerNumber 
     * @param installationNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberOverviewGet(customerNumber: string, installationNumber: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ExpectedConsumptionOverviewResponse>;
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberOverviewGet(customerNumber: string, installationNumber: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ExpectedConsumptionOverviewResponse>>;
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberOverviewGet(customerNumber: string, installationNumber: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ExpectedConsumptionOverviewResponse>>;
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberOverviewGet(customerNumber: string, installationNumber: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (customerNumber === null || customerNumber === undefined) {
            throw new Error('Required parameter customerNumber was null or undefined when calling apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberOverviewGet.');
        }
        if (installationNumber === null || installationNumber === undefined) {
            throw new Error('Required parameter installationNumber was null or undefined when calling apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberOverviewGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (idm) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ExpectedConsumptionOverviewResponse>(`${this.configuration.basePath}/api/consumption/expected/customer/${encodeURIComponent(String(customerNumber))}/installation/${encodeURIComponent(String(installationNumber))}/overview`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param customerNumber 
     * @param installationNumber 
     * @param year 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearGet(customerNumber: string, installationNumber: string, year: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ExpectedConsumptionYearResponse>;
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearGet(customerNumber: string, installationNumber: string, year: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ExpectedConsumptionYearResponse>>;
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearGet(customerNumber: string, installationNumber: string, year: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ExpectedConsumptionYearResponse>>;
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearGet(customerNumber: string, installationNumber: string, year: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (customerNumber === null || customerNumber === undefined) {
            throw new Error('Required parameter customerNumber was null or undefined when calling apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearGet.');
        }
        if (installationNumber === null || installationNumber === undefined) {
            throw new Error('Required parameter installationNumber was null or undefined when calling apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearGet.');
        }
        if (year === null || year === undefined) {
            throw new Error('Required parameter year was null or undefined when calling apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (idm) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ExpectedConsumptionYearResponse>(`${this.configuration.basePath}/api/consumption/expected/customer/${encodeURIComponent(String(customerNumber))}/installation/${encodeURIComponent(String(installationNumber))}/year/${encodeURIComponent(String(year))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param customerNumber 
     * @param installationNumber 
     * @param year 
     * @param month 
     * @param updateExpectedConsumptionRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearMonthMonthPut(customerNumber: string, installationNumber: string, year: number, month: number, updateExpectedConsumptionRequest?: UpdateExpectedConsumptionRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<any>;
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearMonthMonthPut(customerNumber: string, installationNumber: string, year: number, month: number, updateExpectedConsumptionRequest?: UpdateExpectedConsumptionRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<any>>;
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearMonthMonthPut(customerNumber: string, installationNumber: string, year: number, month: number, updateExpectedConsumptionRequest?: UpdateExpectedConsumptionRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<any>>;
    public apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearMonthMonthPut(customerNumber: string, installationNumber: string, year: number, month: number, updateExpectedConsumptionRequest?: UpdateExpectedConsumptionRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (customerNumber === null || customerNumber === undefined) {
            throw new Error('Required parameter customerNumber was null or undefined when calling apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearMonthMonthPut.');
        }
        if (installationNumber === null || installationNumber === undefined) {
            throw new Error('Required parameter installationNumber was null or undefined when calling apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearMonthMonthPut.');
        }
        if (year === null || year === undefined) {
            throw new Error('Required parameter year was null or undefined when calling apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearMonthMonthPut.');
        }
        if (month === null || month === undefined) {
            throw new Error('Required parameter month was null or undefined when calling apiConsumptionExpectedCustomerCustomerNumberInstallationInstallationNumberYearYearMonthMonthPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (idm) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/consumption/expected/customer/${encodeURIComponent(String(customerNumber))}/installation/${encodeURIComponent(String(installationNumber))}/year/${encodeURIComponent(String(year))}/month/${encodeURIComponent(String(month))}`,
            updateExpectedConsumptionRequest,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
